import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class ModifierGroupsManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/modifier-groups',
      params,
      paramsSerializer: qs.stringify,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/modifier-groups',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/modifier-groups/${id}`,
      data,
    });

  delete = (ids, isMaster) =>
    this.request({
      method: 'DELETE',
      url: '/modifier-groups',
      data: {
        ids,
        is_master: isMaster,
      },
    });

  reorder = (ids) =>
    this.request({
      method: 'PUT',
      url: '/modifier-groups-order',
      data: {
        ids,
      },
    });

  toggleVisible = (id, isVisible) =>
    this.request({
      method: 'PATCH',
      url: `/modifier-groups/${id}`,
      data: {
        fields: ['is_visible'],
        is_visible: isVisible,
      },
    });
}
